/* import __COLOCATED_TEMPLATE__ from './who-will-talk-to-fin.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { action } from '@ember/object';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';
import type FinVoiceNumberConfiguration from 'embercom/models/fin-voice/number-configuration';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: any;
    ruleset: $TSFixMe;
    numberConfiguration: FinVoiceNumberConfiguration;
    partialSave: (params: $TSFixMe) => Promise<void>;
  };
}

export default class WhoWillTalkToFin extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare finVoiceConfigService: FinVoiceConfigService;
  @service declare notificationsService: $TSFixMe;

  get numberConfiguration() {
    return this.args.numberConfiguration;
  }

  @action
  async updateOfficeHours(comparison: 'in' | 'nin' | undefined, schedule: string) {
    try {
      await this.finVoiceConfigService.updateOfficeHoursSchedule(
        this.numberConfiguration.workspacePhoneNumber,
        schedule,
        comparison,
      );
      this.notificationsService.notifyConfirmation(
        this.intl.t('operator.fin.setup.setup-and-go-live.notification-messages.success'),
      );
    } catch (error) {
      console.error('error', error);
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t('operator.fin.setup.setup-and-go-live.notification-messages.failure'),
      });
    }
  }

  @action
  async updatePercentageRollout(rollOutPercentage: number) {
    try {
      await this.finVoiceConfigService.updatePercentageRollout(
        this.numberConfiguration.workspacePhoneNumber,
        rollOutPercentage,
      );
      this.notificationsService.notifyConfirmation(
        this.intl.t('operator.fin.setup.setup-and-go-live.notification-messages.success'),
      );
    } catch (error) {
      console.error('error', error);
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t('operator.fin.setup.setup-and-go-live.notification-messages.failure'),
      });
    }
  }

  @action
  async updateWorkspacePhoneNumber(workspacePhoneNumber: string) {
    try {
      await this.finVoiceConfigService.updateWorkspacePhoneNumber(
        this.numberConfiguration?.workspacePhoneNumber,
        workspacePhoneNumber,
      );
      this.notificationsService.notifyConfirmation(
        this.intl.t('operator.fin.setup.setup-and-go-live.notification-messages.success'),
      );
    } catch (error) {
      console.error('error', error);
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t('operator.fin.setup.setup-and-go-live.notification-messages.failure'),
      });
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::WhoWillTalkToFin': typeof WhoWillTalkToFin;
  }
}
